import { Control, Controller } from 'react-hook-form';

import { CurrencyTextInput } from '@/components/form-controls';
import { OverridableCompendiumValue } from '@/types/overridable-compendium-value';
import { formatCurrency } from '@/utils/formatting';

type WacUnitPriceCellProps = {
  ndc: string,
  wacUnit?: OverridableCompendiumValue,
  isOverriding: boolean,
  control: Control<any>
};

export const WacUnitPriceCell = ({ ndc, wacUnit, isOverriding, control }: WacUnitPriceCellProps) => {
  const formKey = `${ndc}.wacUnit`;

  return (
    <div className="min-w-32">
      {isOverriding
        && <Controller
          control={control}
          name={formKey}
          render={({ field: { value, onChange, onBlur } }) => (
            <CurrencyTextInput
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              id={formKey}
              name={formKey}
            />
          )}
        />
      }

      {!isOverriding && wacUnit?.overrideValue != null
        && <span>{formatCurrency(wacUnit.overrideValue)}</span>
      }

      {!isOverriding && wacUnit?.overrideValue == null && wacUnit?.compendiumValue != null
        && <span>{formatCurrency(wacUnit.compendiumValue)}</span>
      }

      {!isOverriding && wacUnit?.overrideValue == null && wacUnit?.compendiumValue == null
        && <span>&mdash;</span>
      }
    </div>
  );
};
